var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40%",
    height: "40%",
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6644 52.3659C41.5719 52.3659 52.0358 41.902 52.0358 28.9945C52.0358 16.0868 41.5719 5.62305 28.6644 5.62305C15.7567 5.62305 5.29297 16.0868 5.29297 28.9945C5.29297 41.902 15.7567 52.3659 28.6644 52.3659Z",
    fill: "#374151",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.643 31.4701L25.6113 37.9832C23.8355 39.0317 21.6533 37.667 21.6533 35.5082V22.4818C21.6533 20.323 23.8355 18.9585 25.6113 20.0068L36.643 26.52C38.47 27.5988 38.47 30.3913 36.643 31.4701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play_circle_icon.8fae492d0a9fe34fbe5c731c17003603.svg";
export { ForwardRef as ReactComponent };